<template>
  <div>
    <v-app id="inspire" v-if="$store.getters.isAuthenticated">
      <v-navigation-drawer
        v-model="drawerRight"
        right="right"
        app
      >
        <v-btn @click="$store.commit('clearFilter')" style="margin: 10px;">Очистить</v-btn>
        <SideFilter title="Цвет" model="color"></SideFilter>
        <SideFilter title="Размер" model="size"></SideFilter>
        <SideFilter title="Бренд" model="brand"></SideFilter>
      </v-navigation-drawer>
      <v-navigation-drawer v-model="drawer" app mini-variant>
        <v-list dense>
          <v-list-item link @click="$router.push({ name: 'home' })">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'calendar' })">
            <v-list-item-action>
              <v-icon>mdi-calendar-month</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="$router.push({ path: '/model/client' })">
            <v-list-item-action>
              <v-icon>mdi-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Клиенты</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group prepend-icon="mdi-cog-outline">
            <template v-slot:activator>
              <v-list-item-title>Справочники</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, key) in menu"
              :key="key"
              link
              @click="$router.push({ path: '/model/' + item.name })"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar app color="orange lighten-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title class="hidden-sm-and-down">imrd.app</v-toolbar-title>
        <v-spacer />
        <v-text-field
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Поиск"
          
          :value="$store.getters.searchstring"
          @input="updateSearch"
        />
        <v-spacer />
        <v-btn class="hidden-sm-and-down" text icon color="dark" @click="$store.commit('authLogout')">
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
        <v-btn text icon color="dark" @click="drawerRight = !drawerRight">
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-app-bar>
      <v-content>
        <router-view />
      </v-content>
    </v-app>
    <v-app id="inspire" v-else>
      <v-content>
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="elevation-12">
                <v-toolbar color="orange lighten-4" flat>
                  <v-toolbar-title>Вход</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <div
                    class="red--text text-center"
                    v-if="error || $store.getters.authError"
                  >
                    {{ error || $store.getters.authError }}
                  </div>
                  <v-form>
                    <v-text-field
                      label="Login"
                      name="login"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="login"
                      :rules="[rules.required]"
                    />

                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="password"
                      :rules="[rules.required]"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" @click="doLogin">Войти</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import SideFilter from './components/Filter';

export default {
  name: "App",
  components: {
    SideFilter
  },

  data: () => ({
    login: "",
    password: "",
    error: "",
    drawer: true,
    drawerRight: false,
    rules: {
      required: value => !!value || "Обязательное поле."
    },
    menu: [
      {
        name: "dress",
        icon: "mdi-hanger"
      },
      {
        name: "event",
        icon: "mdi-calendar"
      },
      {
        name: "client",
        icon: "mdi-account"
      },
      {
        name: "eventtype",
        icon: "mdi-calendar-search"
      },
      {
        name: "color",
        icon: "mdi-palette"
      },
      {
        name: "size",
        icon: "mdi-size-xs"
      }
    ]
  }),

  methods: {
    updateSearch(value) {
      this.$store.commit("dosearch", value);
    },
    doLogin() {
      if (this.login && this.password) {
        this.error = "";
        this.$store.dispatch("authRequest", {
          login: this.login,
          password: this.password
        });
      } else {
        this.error = "Введите логин и пароль";
      }
    }
  }
};
</script>

<style>
.v-dialog {
  background-color: #fff;
}
</style>
